import React,{useState,useRef,useEffect} from 'react'
import { Formik, Field } from 'formik'
import axios from 'axios'
import moment from 'moment'
import DatePicker from "react-datepicker"
import { Loader, Form, Select, Table, Button, Input } from 'semantic-ui-react'
import Spinner from '../../services/spinner'
import AlertMessage from '../../services/alert'
import AlertConfirmation from '../../services/confirmation'
import { WindowReload, WindowURL, WindowLocation, RouteURL, RedirectURL } from '../../services/redirect'

import Paginations from '../../services/paginations'
import EntryList from '../../services/entries'

import { DropdownComponent } from '../../components/options'

import AuthDenied from '../ErrorPage/denied'

import BarChart from "./chart/BarChart"
import LineChart from "./chart/LineChart"
import PieChart from "./chart/PieChart"
import PolarPie from "./chart/PolarArea"


export default function Dashboard(props){

  function ClassModalBody(){
    document.body.classList.add("bgwhite");
  }

  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(false);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
    }
  }


  /*------------------------------------------------------
    ALERT MESSAGE NOTIFY
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
    }
  }


  /*------------------------------------------------------
    ALERT CONFIRMATION
    {intent:'delete',settings:{id:id,centered:false,onclose:true,icon:'warning',title:'Delete Confirmation!',text:'This process is not ireversible. Once you continue the process, the record will be deleted forever on the database.'}}
  -------------------------------------------------------*/
  const [confirm,setconfirm] = useState(true);
  const [confirmcontent, setconfirmcontent] = useState({});
  function Confirmcallback(data){
    if(data.intent=='close'){
      setconfirm(false);
      if(data.reload){
        WindowReload();
      }
    }
  }


  /*------------------------------------------------------
    ORDER BY STATUS
  -------------------------------------------------------*/
  const [totalSpinner, setTotalSpinner] = useState(true);
  const [stateTotal, setStateTotal] = useState({
    total_pending:0,
    total_inprogress:0,
    total_process:0,
    total_orders:0,
  });


  function OrderByTotal(dateFrom,dateTo){
    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setTotalSpinner(true);

    let searchInfo = {
      date_from:dateFrom!=''?moment(new Date(dateFrom)).format('YYYY-MM-DD'):'',
      date_to:dateTo!=''?moment(new Date(dateTo)).format('YYYY-MM-DD'):'',
    }


    let formData = new FormData();
    formData.append('type','order_total');
    formData.append('info',JSON.stringify(searchInfo));
    axios.post('/admin/dashboard/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setStateTotal({
        ...stateTotal,
        total_pending:obj.total_pending,
        total_inprogress:obj.total_inprogress,
        total_process:obj.total_process,
        total_orders:obj.total_orders,
      });

      setTimeout(function() {
        setTotalSpinner(false);
      },1000);


    })
    .catch(function (error){
      setTotalSpinner(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
    });
  }


  /*------------------------------------------------------
    ORDER BY STATUS
  -------------------------------------------------------*/
  const [statusSpinner, setStatusSpinner] = useState(true);
  const [stateStatus, setStateStatus] = useState({
    active_products:0,
    inactive_products:0,
    active_customers:0,
    inactive_customers:0,
  });


  function OrderByStatus(){
    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setStatusSpinner(true);
    
    let formData = new FormData();
    formData.append('type','order_status');
    axios.post('/admin/dashboard/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setStateStatus({
        ...stateStatus,
        active_products:obj.active_products,
        inactive_products:obj.inactive_products,
        active_customers:obj.active_customers,
        inactive_customers:obj.inactive_customers,
      });

      setTimeout(function() {
        setStatusSpinner(false);
      },1000);


    })
    .catch(function (error){
      setStatusSpinner(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
    });
  }


  /*------------------------------------------------------
    ORDER VOLUME
  -------------------------------------------------------*/
  const [volumeSpinner, setVolumeSpinner] = useState(true);
  const [monthLabel, setmonthLabel] = useState('');
  const [monthData, setmonthData] = useState({
    order:0,
    year:moment(new Date()).year(),
    labels: [],
    datasets: [
      {
        label: "",
        data: [],
        backgroundColor: [
          "#21ba45",
          "#e03997",
          "#a333c8",
          "#f2711c",
          "#fbbd08",
          "#b5cc18",
          "#767676",
          "#00b5ad",
          "#6435c9",
          "#a5673f",
        ],
        borderColor: [
          "#21ba45",
          "#e03997",
          "#a333c8",
          "#f2711c",
          "#fbbd08",
          "#b5cc18",
          "#767676",
          "#00b5ad",
          "#6435c9",
          "#a5673f",
        ],
        borderWidth: 1,
      },
    ],
  });

  function OrdersVolume(year){
    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:"Preparing the data, please wait..."}});
    setVolumeSpinner(true);
    let formData = new FormData();
    formData.append('type','order_volume');
    formData.append('year',year);
    axios.post('/admin/dashboard/request.php',formData)
    .then(function (response) {
      let obj = response.data;
      setmonthLabel('');
      setmonthData({
        order:obj.order,
        year:year,
        labels: obj.data.map((data) => data.labelText),
        datasets: [
          {
            label: "",
            data: obj.data.map((data) => data.total),
            backgroundColor: [
              "rgba(33,186,69,0.3)",
              "rgba(224,57,151,0.3)",
              "rgba(163,51,200,0.3)",
              "rgba(242,113,28,0.3)",
              "rgba(251,189,8,0.3)",
              "rgba(181,204,24,0.3)",
              "rgba(118,118,118,0.3)",
              "rgba(0,181,173,0.3)",
              "rgba(100,53,201,0.3)",
              "rgba(165,103,63,0.3)",
            ],
            borderColor: [
              "#21ba45",
              "#e03997",
              "#a333c8",
              "#f2711c",
              "#fbbd08",
              "#b5cc18",
              "#767676",
              "#00b5ad",
              "#6435c9",
              "#a5673f",
            ],
            borderWidth: 2,
          },
        ],
      });

      setVolumeSpinner(false);


    })
    .catch(function (error){
      setVolumeSpinner(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
    });
  }

  function handleSubmitForm(values, props){
      OrdersVolume(values.year);
  }


  /*------------------------------------------------------
          DROPDOWN OPTIONS
  -------------------------------------------------------*/
  const [yearOptions, setyearOptions] = useState([]);
  const HandleOptions = async () => {
    const source = await DropdownComponent();
    setyearOptions(source.order_year);
  }



  /*------------------------------------------------------
    TOP PRODUCTS
  -------------------------------------------------------*/
  const [toproductSpinner, setToproductSpinner] = useState(true);
  const [list, setlist] = useState([]);
	function TopProductList(){
        setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
        setToproductSpinner(true);
				let formData = new FormData();
				formData.append('type','top_products');
				axios.post('/admin/dashboard/request.php',formData)
				.then(function (response) {
            let obj = response.data;
						setlist(obj);
            setToproductSpinner(false);
				})
				.catch(function (error){
          setToproductSpinner(false);
				});
	}


  /*------------------------------------------------------
    SEARCH
  -------------------------------------------------------*/
  const [search, setsearch]  = useState({
      date_from:'',
      date_to:'',
      date_min:'',
  });

  function handleSubmitForm(values, props){
    if(values.date_from==''||values.date_to==''){
      return false;
    }
    OrderByTotal(values.date_from,values.date_to);
  }



  /*------------------------------------------------------
         AUTH PERMISSION FOR PAGES
  -------------------------------------------------------*/
  const [loader,setloader] = useState(true);
  const [pageId, setPageId] = useState('d5n26pvm3fk17hbgc');
  const [authPages, setAuthPages] = useState({
    view:0,
    adding:0,
    editing:0,
    deleting:0
  });
  function AuthPagesPermission(){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setloader(true);

    let formData = new FormData();
    formData.append('type','authPages');
    formData.append('id',pageId);
    axios.post('/admin/users-management/users-permission/request.php',formData)
    .then(function (response) {
        let obj = response.data;

        setAuthPages({
          view:obj.view,
          adding:obj.adding,
          editing:obj.editing,
          deleting:obj.deleting,
        });

        // Load page when view permission is granted
        if(obj.view==1){
          ClassModalBody();
          HandleOptions();
          OrderByStatus();
          OrderByTotal('','');
          TopProductList();
          OrdersVolume(moment(new Date()).year()-1);
        }
        setloader(false);

    })
    .catch(function (error){
      setloader(false);
      setspinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
 }

  useEffect(()=>{
    // Load Permission
    AuthPagesPermission();
  },[]);

  return (
    <React.Fragment>
      <br/>

      {confirm&&<AlertConfirmation data={confirmcontent} callback={Confirmcallback}/>}
      {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}


      {(authPages['view']==0&&!loader)&&<AuthDenied/>}
      {(authPages['view']==1&&!loader)&&<React.Fragment>

      <div>
         {/*---------------------------------------------------------
          SEARCH SECTION
         --------------------------------------------------------*/}
        <Formik
          initialValues={search}
          onSubmit={handleSubmitForm}
          >
         {({ values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue, setFieldTouched }) => {

         const CustomDateFrom = ({ value, onClick }) => (
           <Input iconPosition='left' onClick={onClick} value={values.date_from}><i className='uil-calender icon'></i><input /></Input>
         );
         const CustomDateTo = ({ value, onClick }) => (
           <Input iconPosition='left' onClick={onClick} value={values.date_to}><i className='uil-calender icon'></i><input /></Input>
         );

 
         return(<React.Fragment>
           <div className="search-dashboard">
              <div>
                <Form>
                    <Form.Group widths="equal">
                        <Field name="date_from">
                            {({ field, form }) => (
                            <Form.Field>
                              <DatePicker
                                showYearDropdown
                                yearDropdownItemNumber={100}
                                scrollableYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                                selected={values.date_from!=''?new Date(values.date_from):null}
                                onChange={date => {
                                   var dateselected 	= moment(new Date(date)).format('DD MMMM YYYY');
                                   var formindate 		= moment(new Date(date)).add(0, 'days');
                                   setFieldValue('date_min',new Date(formindate));
                                   setFieldValue('date_from',dateselected);
                                   setFieldValue('date_to',dateselected);
                                }}
                                customInput={<CustomDateFrom />}
                              />
                            </Form.Field>
                            )}
                        </Field>
                        <Field name="date_to">
                            {({ field, form }) => (
                            <Form.Field>
                              <DatePicker
                                showYearDropdown
                                yearDropdownItemNumber={100}
                                scrollableYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                                selected={values.date_to!=''?new Date(values.date_to):null}
                                minDate={values.date_min}
                                onChange={date => {
                                  var dateselected 		= moment(new Date(date)).format('DD MMMM YYYY');
                                  setFieldValue('date_to',dateselected);
                                }}
                                customInput={<CustomDateTo />}
                              />
                            </Form.Field>
                            )}
                        </Field>

                       
                    </Form.Group>
                 </Form>
              </div>
              <div>
                <Button type="button" icon='search' size='medium' className="LightGrayButton" content='Search' onClick={handleSubmit}/>
                <Button type="button" size='medium' className="LightGrayButton" content='Reset' onClick={() => {
                  setFieldValue('date_min','');
                  setFieldValue('date_from','');
                  setFieldValue('date_to','');
                  OrderByTotal('','')
                }}/>
              </div>
           </div>
        </React.Fragment>
        )}}
        </Formik>
      </div>


      {/*-------------------------------------------------------------------------
         STATUS REPORTS DASHBOARD
        ------------------------------------------------------------------------*/}
      <div className="boxContainer">
        <div className="boxWrapper Purple">
            <div>
                {totalSpinner&&<h2><Loader size='small' active inline /></h2>}
                {!totalSpinner&&<h2>{stateTotal.total_orders}</h2>}
                <p>Total Orders</p>
            </div>
            <div>
               <span className="spanCircle"><span><i className="flaticon-box"></i></span></span>
            </div>
        </div>
        <div className="boxWrapper Green">
            <div>
                {totalSpinner&&<h2><Loader size='small' active inline /></h2>}
                {!totalSpinner&&<h2>{stateTotal.total_process}</h2>}
                <p>Orders Processed</p>
            </div>
            <div>
               <span className="spanCircle"><span><i className="flaticon-calendar-2"></i></span></span>
            </div>
        </div>
        <div className="boxWrapper Orange">
            <div>
                {totalSpinner&&<h2><Loader size='small' active inline /></h2>}
                {!totalSpinner&&<h2>{stateTotal.total_inprogress}</h2>}
                <p>Orders In Progress</p>
            </div>
            <div>
               <span className="spanCircle"><span><i className="flaticon-user-8"></i></span></span>
            </div>
        </div>
        <div className="boxWrapper Red">
            <div>
                {totalSpinner&&<h2><Loader size='small' active inline /></h2>}
                {!totalSpinner&&<h2>{stateTotal.total_pending}</h2>}
                <p>Pending Orders</p>
            </div>
            <div>
               <span className="spanCircle"><span><i className="flaticon-calendar-3"></i></span></span>
            </div>
        </div>
      </div>

      <br/>

      <div className="boxContainer">
        <div className="boxWrapper Green">
            <div>
                {statusSpinner&&<h2><Loader size='small' active inline /></h2>}
                {!statusSpinner&&<h2>{stateStatus.active_products}</h2>}
                <p>Active Products</p>
            </div>
            <div>
               <span className="spanCircle"><span><i className="flaticon-checked"></i></span></span>
            </div>
        </div>
        <div className="boxWrapper Pink">
            <div>
                {statusSpinner&&<h2><Loader size='small' active inline /></h2>}
                {!statusSpinner&&<h2>{stateStatus.inactive_products}</h2>}
                <p>In-Active Products</p>
            </div>
            <div>
               <span className="spanCircle"><span><i className="flaticon-pen"></i></span></span>
            </div>
        </div>
        <div className="boxWrapper Blue">
            <div>
                {statusSpinner&&<h2><Loader size='small' active inline /></h2>}
                {!statusSpinner&&<h2>{stateStatus.active_customers}</h2>}
                <p>Active Customers</p>
            </div>
            <div>
               <span className="spanCircle"><span><i className="flaticon-user-5"></i></span></span>
            </div>
        </div>
        <div className="boxWrapper Red">
            <div>
                {statusSpinner&&<h2><Loader size='small' active inline /></h2>}
                {!statusSpinner&&<h2>{stateStatus.inactive_customers}</h2>}
                <p>In-Active Customers</p>
            </div>
            <div>
               <span className="spanCircle"><span><i className="flaticon-user-4"></i></span></span>
            </div>
        </div>
      </div>


      {/*-------------------------------------------------------------------------
         ORDER VOLUME MONTH AND YEAR
        ------------------------------------------------------------------------*/}
      {volumeSpinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
      {!volumeSpinner&&<React.Fragment>
        <br/>
        <div className="graphWrapper">
        <Formik
          initialValues={monthData}
          onSubmit={handleSubmitForm}
          render={formProps => {
          const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, touched, setFieldValue } = formProps
          return(<React.Fragment>
             <Form>
                <div className="graphWrapper-container">
                  <div className="graphWrapper-title">
                      <div>
                          <h1>Monthly Order Volume</h1>
                          <p>Year {values.year}</p>
                      </div>
                      <div>
                        <Form.Group widths="equal">
                            <Field name="year">
                                {({ field, form }) => (
                                <Form.Field>
                                  <Select
                                  compact
                                  selectOnBlur={false}
                                      {...field}
                                      options={yearOptions}
                                      onChange={(e, { value }) => {
                                        setFieldValue(field.name,value);
                                        OrdersVolume(value);
                                      }}/>
                                </Form.Field>
                                )}
                            </Field>
                        </Form.Group>
                      </div>
                  </div>
                  {values.order==0&&<div className="chartNodata">
                     <div className="alert-message error center">
                        <div><h4>No Record Found</h4></div>
                        <div>There is no montly volume in {values.year}.</div>
                     </div>
                  </div>}
                  <div className="chartWrapper">
                    <BarChart chartData={monthData} />
                  </div>
                </div>

            </Form>
          </React.Fragment>)}}/>
          </div>
      </React.Fragment>}



      {/*---------------------------------------------------------
          TOP products
         --------------------------------------------------------*/}
      <br/>
      {toproductSpinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

      {(!toproductSpinner&&list.length>0)&&<React.Fragment>
      <div className="graphTitle">
        <h1>Top {list.length} Products</h1>
        <p>List of most ordered products</p>
      </div>
      <div className="tableWrapper">
       <div className="panel-table">
         <div className="panel-table-body">
         <div className="table-responsive overflow">
           <Table celled compact='very'>
             <Table.Header>
               <Table.Row>
                 <Table.HeaderCell style={{'white-space':'nowrap'}}>Rank #</Table.HeaderCell>
                 <Table.HeaderCell>Name</Table.HeaderCell>
                 <Table.HeaderCell>Code</Table.HeaderCell>
                 <Table.HeaderCell style={{'background-color':'#f4e8ff'}}># of Orders</Table.HeaderCell>
                 <Table.HeaderCell style={{'background-color':'#dcfce7'}}># of Quantity</Table.HeaderCell>
               </Table.Row>
             </Table.Header>
             <Table.Body>
               {list.map(function(data, key){
                 return <Table.Row key={key} verticalAlign='top'>
                     <Table.Cell collapsing>{data.rank}</Table.Cell>
                     <Table.Cell>{data.name}</Table.Cell>
                     <Table.Cell>{data.code}</Table.Cell>
                     <Table.Cell style={{'background-color':'#f4e8ff'}}><strong>{data.total_order}</strong></Table.Cell>
                     <Table.Cell style={{'background-color':'#dcfce7'}}><strong>{data.total_quantity}</strong></Table.Cell>
                 </Table.Row>
               })}
            </Table.Body>
           </Table>
          </div>{/*.table-responsive*/}
         </div>{/*.panel-table-body*/}
        </div>{/*.panel-table*/}
        </div>
      </React.Fragment>}


    </React.Fragment>}
    </React.Fragment>
  )
}
